import { Component, Input } from '@angular/core';

@Component({
  selector: 'xpo-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  host: {
    class: 'xpo-Footer',
  },
})
export class XpoFooterComponent {
  @Input() version: string;
  currentYear: number = new Date().getFullYear();
}
